import { QuoteReservation } from '@/models/quote'

// This util is necessary to keep track of
// 1) amount of a single specific service added to cart
// 2) amount of the same single service selected on the current open spot in SelectedElementDrawer
// the end goal is to avoid surpassing the service limit and prevent overbooking
export const sumServiceQuantityInCart = ({
  cartReservations,
  selectedElementCartReservation,
  serviceKey,
}: {
  cartReservations: QuoteReservation[]
  selectedElementCartReservation?: QuoteReservation
  serviceKey: string
}) => {
  const serviceInCartQuantity = cartReservations
    .filter(
      (reservation) =>
        reservation.services[serviceKey] &&
        (reservation.spotName !== selectedElementCartReservation?.spotName ||
          reservation.spotType !== selectedElementCartReservation?.spotType)
    )
    .reduce((sum, item) => {
      return sum + item.services[serviceKey]
    }, 0)

  return serviceInCartQuantity
}
